<template>
    <div>
     <el-tabs v-model="tabsKey"
         type="card">
         <el-tab-pane name="set" label="規則設定">
          <set />
         </el-tab-pane>
         <el-tab-pane name="change" label="兌換中心" >
         <change />
         </el-tab-pane>
     </el-tabs>
     
    </div>
</template>

<script>
import set from './Memberpoint/set'
import change from './Memberpoint/change'
    export default {
        name: 'MemberPoint',
        components: {
            set,
            change
        },
        data() {
            return {
                tabsKey: 'set'
            }
        },
    }
</script>